const parseProducts = (products) => {
	let parsedProducts = false;

	if (products) {
		let activeProducts = {};
		let returnedProducts = {};

		for (const product of products) {
			const prodID = product.product.id;
			if (product.status === 2) {
				if (returnedProducts[prodID]) {
					returnedProducts[prodID].quantity = returnedProducts[prodID].quantity + 1;
					returnedProducts[prodID].ids.push(product.id);
				}
				else {
					returnedProducts[prodID] = { ...product, id: product.product.id, ids: [product.id], quantity: 1 };
				}
			}
			else {
				if (activeProducts[prodID]) {
					activeProducts[prodID].quantity = activeProducts[prodID].quantity + 1;
					activeProducts[prodID].ids.push(product.id);
				}
				else {
					activeProducts[prodID] = { ...product, id: product.product.id, ids: [product.id], quantity: 1 };
				}
			}
		}

		parsedProducts = { active: [], returned: [] };

		for (const prod in activeProducts) {
			parsedProducts.active.push({ ...activeProducts[prod], total_price: (parseFloat(activeProducts[prod].price_new) * activeProducts[prod].quantity) });
		}
		for (const prod in returnedProducts) {
			parsedProducts.returned.push({ ...returnedProducts[prod], total_price: (parseFloat(returnedProducts[prod].price_new) * returnedProducts[prod].quantity) });
		}
	}

	return parsedProducts;
}

export default parseProducts